import * as React from "react";
import { ComplaintContainer } from "../complaint/Complaint.styled";
import { ButtonSecondary } from "../login.screen/login.styled";
import { MiniNav, MoveInHeader } from "../MoveIn.screen/MoveIn.styled";
import { TabWithCount } from "../SocialCase/SocialCase";
import {
  Box,
  Modal,
  Tab,
  Tabs,
  Typography,
  CircularProgress,
} from "@mui/material";
import { a11yProps } from "../Tabs.MUI/Tabs.interface";
import { TabPanel } from "../MoveInRegistration/MoveInRegistration";
import General from "../../stores/GeneralStore";
import User from "../../stores/UserStore";
import { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Property } from "../../components/move-inRegistrationTabs/PropertyDetailsTab";
import { OwnerPropertyDetails } from "../../components/OwnerPropertyDetails/OwnerPropertyDetails";
import Thankyou from "../../components/SocialCaseTbas/Thankyou";
import MoveInOut from "../../stores/MoveInOutStore";
import ErrorSubscription from "../../stores/ErrorSubscriptionStore";
import { NotifyError } from "../../utils/ShowError";
import ServiceActivationOtp from "../../components/ServiceActivation/ServiceActivationOtp";

const ServiceActivation = () => {
  const [value, setValue] = useState(0);
  const [premiseId, setPremiseId] = useState("");
  const [error, setError] = useState("");
  const [statusMessage, setStatusMessage] = useState<any>({});
  const [serviceId, setServiceId] = useState(5); // 3 for Service Activation
  const navigate = useNavigate();
  const ColorAss = General?.ColorAss;
  const contrast = General?.contrast;

  const [otpModalOpen, setOTPModalOpen] = useState(false);
  const [orderId, setOrderId] = useState<any>();
  const [register, setRegister] = useState(false);
  const [registerLoader, setRegisterLoader] = useState(false);
  const [messageTitle, setTitle] = useState<any>();
  const [tenantLoader, setTenantLoader] = useState(false);
  const [ownerLoader, setOwnerLoader] = useState(false);
  const [disabledBtn, setDisabled] = useState<any>(false);
  const [attempts, setAttempts] = useState(0);
  const [isRecaptchaVerified, setIsRecaptchaVerified] = useState(false);
  const [loading, setIsLoading] = useState(false);
  const [isLargeScreen, setIsLargeScreen] = useState(false);
  const [proceedToShowDetails, setProceedToShowDetails] = useState(false);
  const [referenceId, setReferenceId] = useState("");
  const sewerageNumberRef = useRef<HTMLInputElement | null>(null);
  const [captchaToken, setCaptchaToken] = useState("");
  const [captchareset, setCaptchareset] = useState(false);
  

  useEffect(() => {
    function handleResize() {
      setIsLargeScreen(window.innerWidth > 991);
    }
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Tab change logic
  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  // Input change
  // const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
  //   setPremiseId(e.target.value);
  //   setError("");
  //   setResult(null);
  // };

  // Simulate search
  // const handleSearch = async () => {
  //   if (!premiseId.trim()) {
  //     setError("Premise ID is required");
  //     return;
  //   }
  //   setValidateLoader(true);
  //   setError("");
  //   setResult(null);
  //   try {
  //     await new Promise((res) => setTimeout(res, 1000));
  //     setResult({ premiseId, status: "Found (mocked)" });
  //     setValue(1);
  //   } catch (e) {
  //     setError("Error searching for premise");
  //   } finally {
  //     setValidateLoader(false);
  //   }
  // };
  const handleGetDetails = async () => {
    setDisabled(false);
    setPremiseId(sewerageNumberRef.current?.value || "");
    localStorage.removeItem("otpData");
    localStorage.removeItem("type");
    localStorage.removeItem("largeId");
    localStorage.removeItem("businessType");
    ErrorSubscription.unSubscribeAll();
    General?.handleBackClick(); //remoce errors obj
    MoveInOut?.clearCache(); //remoce errors obj
    User?.clearCache(); //remoce errors obj
    // setIsMoveInLoginWithNoDue(false);today
    try {
      if (sewerageNumberRef.current && sewerageNumberRef.current?.value) {
        setIsLoading(true);
        const dataWithError = {
          data: { 
            premiseId : sewerageNumberRef.current!.value,
            recaptchaToken: captchaToken,
            platform: "Web"
           },
          errorId: "propertySewerageError",
        };
      

        if (!isRecaptchaVerified) {
          // Disable the button after three attempts if reCAPTCHA is not verified
          setIsLoading(false); // Stop loading
          return;
        }
        setAttempts(attempts + 1);
        var getPremiseRes;
        if (User?.profile?.personId) {
          getPremiseRes = await General.handlePremiseDetails(dataWithError);
        } else {
          getPremiseRes = await General.handlePremiseDetailsNoToken(
            dataWithError
          );
        }
        console.log("getPremiseRes", getPremiseRes);
          if (!getPremiseRes){
        setCaptchareset(true);
       }
         if(!General?.premise){
            setCaptchareset(true);
            setIsRecaptchaVerified(false);
          }
        if (General?.premise) {
          const {
            ownerAccount,
            tenantAccount,
            isConnected,
            isVacant,
            networkType,
          } = getPremiseRes || {};
          const userPersonId = User?.profile?.personId;

          const showError = (labelKey: any) => {
            NotifyError(
              General?.codeLabels[labelKey]?.label?.replace(
                "{0}",
                sewerageNumberRef.current?.value
              )
            );
            setProceedToShowDetails(false);
            setIsLoading(false);
          };

          if (!ownerAccount?.personID) {
            showError("cm_noowner");
          } else if (ownerAccount.personID !== userPersonId) {
            showError("cm_person_not_owner");
          } else if (networkType !== "INSIDE") {
            showError("cm_prem_not_within_network");
            setProceedToShowDetails(false);
          } else if (isConnected !== "Y") {
            showError("cm_prem_not_connected");
          } else if (isVacant !== "Y") {
            showError("cm_prem_not_vacant");
          } else if (tenantAccount?.personID) {
            showError("cm_prem_fnd_uos");
          } else {
            // All validations passed
            setProceedToShowDetails(true);
            setIsLoading(false);
          }
          setRegisterLoader(false);
        }

        if (
          General?.premise?.tenantAccount == null &&
          General?.premise?.ownerAccount == null
        ) {
          setDisabled(true);
        }
      }
    } catch (error) {
      setIsLoading(false);
      setCaptchareset(true);
    }
  };

  const handleServiceActivation = async (
    otp: string,
    transactionId: string
  ) => {
    if (premiseId) {
      const payload = {
        premiseId,
        otpData: {
          oneTimePasswordConfirm: otp,
          otp: otp,
          estimatedBillId: "",
          platform: "Web",
          amount: 0,
          accountId: "",
          personId: User?.profile?.personId,
          isMoveIn: true,
          transactionId: transactionId,
        },
      };
      try{
        const result = await General?.ownerServiceActivation({
        errorId: "serviceActivationError",
        data: payload,
      });
      if (result) {
        setValue(2);

        if (Number(result?.statusCode) === -1) {
          const [message, number] = result?.statusMessage.split("|");
          setStatusMessage(message.toLowerCase());
          setReferenceId(number);
        } else {
          console.log("got into else");
          setStatusMessage(result?.statusMessage.toLowerCase());
          setReferenceId(result?.caseId);
        }
      }
      }
      catch (error) {
        setIsLoading(false);
        NotifyError("Something went wrong, please try again.")
      }
      
      
    }
  };
useEffect(() => {
      if (captchareset) {
        setCaptchaToken("");
        setIsRecaptchaVerified(false);
        setCaptchareset(false); // 🔑 IMPORTANT
      }
    }, [captchareset]);
  // Header and nav
  return (
    <div
      style={{
        backgroundColor:
          value === 3
            ? ""
            : contrast?.contrastBackground
            ? contrast?.contrastBackground
            : "#fff",
      }}
    >
      <MoveInHeader
        style={{
          color: contrast?.contrastColor ? contrast?.contrastColor : "#fff",
          background: contrast?.contrastBackground
            ? contrast?.contrastBackground
            : ColorAss === "#101E8E"
            ? "#62aa51"
            : ColorAss,
        }}
      >
        <div>
          <MiniNav>
            <ButtonSecondary
              style={{
                color: contrast?.contrastBackground
                  ? contrast?.contrastBackground
                  : "#fff",
                background: contrast?.contrastColor
                  ? contrast?.contrastColor
                  : ColorAss === "#101E8E"
                  ? "#62aa51"
                  : ColorAss,
                width: "81px",
                height: "30px",
                border: "1px solid #FFF",
                fontSize: `${General.accessibility.fontSize}rem`,
                zIndex: "0",
              }}
              onClick={() => {
                navigate("/dashboard");
              }}
            >
              {General?.codeLabels["cm_back"]?.label
                ? General?.codeLabels["cm_back"]?.label
                : "BACK"}
            </ButtonSecondary>
            {User?.info?.personId && (
              <ButtonSecondary
                style={{
                  color: contrast?.contrastBackground
                    ? contrast?.contrastBackground
                    : "#fff",
                  background: contrast?.contrastColor
                    ? contrast?.contrastColor
                    : ColorAss === "#101E8E"
                    ? "#62aa51"
                    : ColorAss,
                  width:
                    General?.codeLabels["cm_pdc_paymentaccounts"]
                      ?.languageCode == "ARA"
                      ? "12rem"
                      : "117px",
                  height: "30px",
                  border: "1px solid #FFF",
                  fontSize: `${General.accessibility.fontSize}rem`,
                  zIndex: "0",
                }}
                onClick={() => navigate("/dashboard")}
              >
                {General?.codeLabels["cm_dashboard"]?.label
                  ? General?.codeLabels["cm_dashboard"]?.label
                  : "DASHBOARD"}
              </ButtonSecondary>
            )}
          </MiniNav>
          <h1
            style={{
              fontFamily: "Segoe UI",
              fontStyle: "normal",
              fontWeight: "400",
              fontSize: isLargeScreen
                ? `${3.1 * General.accessibility.fontSize}rem`
                : `${2 * General.accessibility.fontSize}rem`,
              margin: "0",
              color: contrast?.contrastColor ? contrast?.contrastColor : "",
            }}
          >
            {General?.codeLabels["cm_movein_service_activation"]?.label ||
              "Move-in Service Activation"}
          </h1>
        </div>
      </MoveInHeader>
      <ComplaintContainer
        style={{
          backgroundColor: contrast?.contrastBackground
            ? contrast?.contrastBackground
            : "#fff",
          marginTop: value == 3 ? "1rem" : "",
        }}
      >
        <Box
          sx={{
            width: value === 3 ? "100%" : isLargeScreen ? "80%" : "100%",
            paddingTop: value == 3 ? "0rem" : "2.5rem",
          }}
        >
          {value != 3 && (
            <Box
              sx={{
                display: "flex",
                marginLeft: isLargeScreen ? "" : "1rem",
                justifyContent: General?.isLargeScreen ? "" : "center",
              }}
            >
              <Tabs
                value={value}
                onChange={handleChange}
                aria-label="basic tabs example"
                sx={{
                  alignSelf: "flex-end",
                  marginBottom: "0px",
                  zIndex: "0",
                  width: { md: "70%", lg: "100%" },
                }}
                variant="scrollable"
                // scrollButtons
                allowScrollButtonsMobile
              >
                <Tab
                  label={
                    <TabWithCount value={value} count={1}>
                      {General?.isLargeScreen && (
                        <span
                          style={{
                            fontSize: `${General.accessibility.fontSize}rem`,
                            color: contrast?.contrastColor
                              ? contrast?.contrastBackground
                              : General?.ColorAss,
                          }}
                        >
                          {"Owner Property Details"}
                        </span>
                      )}
                    </TabWithCount>
                  }
                  // className="mui-move-in"
                  {...a11yProps(0)}
                  sx={{
                    background: General?.isLargeScreen
                      ? contrast?.contrastColor
                        ? contrast?.contrastColor
                        : "#e7e9f8"
                      : "",
                    color: contrast?.contrastBackground
                      ? contrast?.contrastBackground
                      : "#101e8e",
                    margin: "0.2rem",
                    marginBottom: "0",
                    width: "32.5%",
                    "&.Mui-selected": {
                      outline: "none",
                    },
                  }}
                  disabled
                />
                <Tab
                  label={
                    <TabWithCount count={2} value={value}>
                      {General?.isLargeScreen && (
                        <span
                          style={{
                            fontSize: `${General.accessibility.fontSize}rem`,
                            color: contrast?.contrastColor
                              ? contrast?.contrastBackground
                              : General?.ColorAss,
                          }}
                        >
                          {"Otp Verification"}
                        </span>
                      )}
                    </TabWithCount>
                  }
                  // className="mui-move-in"
                  {...a11yProps(1)}
                  sx={{
                    background: General?.isLargeScreen
                      ? contrast?.contrastColor
                        ? contrast?.contrastColor
                        : "#e7e9f8"
                      : "",
                    color: contrast?.contrastBackground
                      ? contrast?.contrastBackground
                      : "#101e8e",
                    margin: "0.2rem",
                    marginBottom: "0",
                    width: "32.5%",
                    zIndex: "0",
                    "&.Mui-selected": {
                      outline: "none",
                    },
                  }}
                  disabled
                />

                <Tab
                  label={
                    <TabWithCount
                      className="DynamicTextColor"
                      count={3}
                      value={value}
                    >
                      {General?.isLargeScreen && (
                        <span
                          style={{
                            fontSize: `${General.accessibility.fontSize}rem`,
                            color: contrast?.contrastColor
                              ? contrast?.contrastBackground
                              : General?.ColorAss,
                          }}
                        >
                          {"Thank You"}
                        </span>
                      )}
                    </TabWithCount>
                  }
                  // className="mui-move-in"
                  {...a11yProps(2)}
                  sx={{
                    background: General?.isLargeScreen
                      ? contrast?.contrastColor
                        ? contrast?.contrastColor
                        : "#e7e9f8"
                      : "",
                    color: contrast?.contrastBackground
                      ? contrast?.contrastBackground
                      : "#101e8e",
                    margin: "0.2rem",
                    marginBottom: "0",
                    width: "32.5%",
                    zIndex: "0",
                    "&.Mui-selected": {
                      outline: "none",
                    },
                  }}
                  disabled
                />
              </Tabs>
            </Box>
          )}
          <TabPanel value={value} index={0}>
            <OwnerPropertyDetails
              premise={General.premise}
              checkOwner={() => {
                setValue(1);
                localStorage.setItem("TabValue", "1");
              }} // Implement as needed
              checkTenant={() => {}} // Implement as needed
              onClick={handleGetDetails} // Implement as needed
              loading={loading}
              disabledBtn={disabledBtn}
              ownerLoading={ownerLoader}
              tenantLoader={tenantLoader}
              Next={() => {
                setValue(1);
                localStorage.setItem("TabValue", "1");
              }}
              sewerageRef={sewerageNumberRef}
              ownerButton={true}
              handleGetDetails={handleGetDetails} // Implement as needed
              attempts={attempts}
              setAttempts={setAttempts}
              isRecaptchaVerified={isRecaptchaVerified}
              setIsRecaptchaVerified={setIsRecaptchaVerified}
              serviceActivation={true}
              showDetails={proceedToShowDetails}
              setCaptchaToken={setCaptchaToken}
              resetCaptcha={captchareset} 
            />
          </TabPanel>
          <TabPanel value={value} index={1}>
            <ServiceActivationOtp
              mobile={User?.profile?.mobileNumber}
              personID={User.profile?.personId}
              email={User?.profile?.email}
              onClose={() => {
                setValue(0);
                setProceedToShowDetails(false);
                setIsLoading(false);
              }}
              onVerify={(otp: string, transactionId: string) => {
                handleServiceActivation(otp, transactionId);
              }}
            />
          </TabPanel>
          <TabPanel value={value} index={2} width="100%">
            <Thankyou
              title={
                statusMessage
                  ? General?.codeLabels[statusMessage]?.label?.replace(
                      "{0}",
                      statusMessage.caseId ? statusMessage.caseId : referenceId
                    )
                  : "Service Activation"
              }
              referenceId={referenceId}
              serviceID={serviceId}
              // downloadLoader={downloadLoader}
              // downloadBillPDF={downloadBillPDF}
            />
          </TabPanel>
        </Box>
      </ComplaintContainer>
      {/* <Modal open={showPendingOrderDialog} onClose={handleTypeModalClose}>
        <PendingOrderModal closeModal={() => setShowPendingOrderDialog(false)} />
      </Modal>
      <Modal open={openPendingDue} onClose={handleTypeModalClose}>
        <PendingDuesModal payNow={() => { setOpenCards(true); setOpenPendingDue(false); }} closeModal={handleClosePendingDue} />
      </Modal>
      <Modal open={isUserExist} onClose={handleTypeModalClose}>
        <UserExistModal isUserExistUsername={isUserExistUsername} isUserExistPersonId={isUserExistPersonId} onValidateClick={() => { navigate('/'); localStorage.removeItem('value'); }} />
      </Modal>
      <Modal open={typeModalOpen} onClose={handleTypeModalClose}>
        <TypeModal onClose={handleTypeModalClose} validateLoader={validateLoader} setValidateLoader={setValidateLoader} onValidateClick={handleValidateClick} />
      </Modal>
      <Modal open={openCards} onClose={handleCardsModalClose}>
        <CardsPopup
          onClose={handleCardsModalClose}
          makePayment={() => {}} // Implement as needed
          fromAutoPay={false}
          amount={0} // Set actual amount
          paymentLoader={paymentLoader}
          emailForm={true}
        />
      </Modal>
      <Modal open={otpModalOpen} onClose={handleOtpModalClose}>
        <VerifyAndPay
          registrationLoader={registerLoader}
          premiseId={General.premise.premiseId}
          email={newEmailId}
          mobile={newMobileNum}
          personID={personLargeId}
          onClose={handleOtpModalClose}
          onVerify={() => {}} // Implement as needed
          isModal={false}
          isMovein={true}
          Previous={() => {
            General?.handleBackClick();
            setValue(0)
            localStorage.setItem('TabValue', '0')
            setOTPModalOpen(false);
          }}
        />
      </Modal> */}
    </div>
  );
};

export default ServiceActivation;
